// WakeLock utility for keeping the screen awake in web apps
// Usage: import { setupWakeLock } from "./wake-lock";
// Call setupWakeLock(scene) after your scene is available

let wakeLock = null;

export async function requestWakeLock() {
  try {
    if ("wakeLock" in navigator) {
      wakeLock = await navigator.wakeLock.request("screen");
      wakeLock.addEventListener("release", () => {
        // console.log("Wake Lock was released");
      });
      // console.log("Wake Lock is active");
    }
  } catch (err) {
    console.error("Wake Lock request failed:", err);
  }
}

export function releaseWakeLock() {
  if (wakeLock && wakeLock.release) {
    wakeLock.release();
    wakeLock = null;
  }
}

// Sets up WakeLock for the app: requests on scene load, re-requests on visibility change, releases on unload
export function setupWakeLock(scene) {
  // Request wake lock when the scene is loaded
  if (scene.hasLoaded) {
    requestWakeLock();
  } else {
    scene.addEventListener("loaded", requestWakeLock, { once: true });
  }

  // Re-request wake lock on visibility change
  document.addEventListener("visibilitychange", () => {
    if (wakeLock !== null && document.visibilityState === "visible") {
      requestWakeLock();
    }
  });

  // Release wake lock on page unload
  window.addEventListener("unload", releaseWakeLock);
}
